import React from 'react'
import FuboFreeTemplate from 'src/components/template/fubofree'
import { ratePlanCodes } from 'src/constants'
import { commonCtaText } from 'src/modules/utils/constants'
export default (props) => {
  return (
    <FuboFreeTemplate
      location={props.location}
      lang="en"
      market="us"
      video={
        'https://assets-imgx.fubo.tv/marketing/lp/videos/compressed/FOX_Nation_LP_Web_10s_3mb.mp4'
      }
      videoMobile={
        'https://assets-imgx.fubo.tv/marketing/lp/videos/mobile/FOX_Nation_LP_Mobile_10s_3mb-v2.mp4'
      }
      title="Watch FOX Nation with Fubo"
      subtitle="Only $8.99/mo. Fubo base plan not required."
      networkSet="standalone_networks"
      ctaText={commonCtaText.getAccess}
      maxNetworkCount={7}
      additionalFAQs={additionalFAQs}
      offerCode={ratePlanCodes.fox_nation_mo}
      disableFreeTrial={true}
    />
  )
}

const additionalFAQs = [
  {
    question: 'Can I watch The Killer Interview with Piers Morgan on Fubo?',
    answer:
      'Yes, you can watch The Killer Interview with Piers Morgan on Fubo as it is available on Fox Nation.',
  },
  {
    question: 'Is Tomi Lahren Is Fearless available to watch on Fubo?',
    answer: 'Yes, Tomi Lahren Is Fearless is available on Fubo through the Fox Nation channel.',
  },
  {
    question: 'How can I find The Fall of the House of Murdaugh on Fubo?',
    answer:
      'You can find The Fall of the House of Murdaugh on Fubo by searching for it directly in the app or by browsing the Fox Nation channel.',
  },
  {
    question: 'Can I watch CrimeCam 24/7 live on Fubo?',
    answer:
      'Yes, CrimeCam 24/7 is available for viewing on Fubo, specifically through the Fox Nation channel.',
  },
  {
    question: 'Does Fubo provide live news coverage?',
    answer:
      'Yes, Fubo offers live local, national and international news coverage from a wide variety of sources, allowing you to stay updated on current events and politics.',
  },
  {
    question: 'What features does Fubo offer for watching specific shows?',
    answer:
      'Fubo provides features like a search function and personalized recommendations, making it easy to find and watch specific shows like The Killer Interview with Piers Morgan. You can also watch multiple channels at once with Multiview, which allows you to flip back and forth between up to four different news shows, sporting events and more.',
  },
]
